/**
 * Bank account route resolution (matches Profile.vue bankAccount link logic).
 * Used by profile requirements modal only.
 */

const BANK_REQUIREMENT_KEYS = new Set([
    'account_name',
    'bsb',
    'account_number',
]);

export function isBankRequirementItem(item) {
    return item?.navigation === 'bank_account' || BANK_REQUIREMENT_KEYS.has(item?.key);
}

/**
 * @param {object} user - Vuex GET_USER_DATA
 * @returns {string}
 */
export function resolveBankAccountRouteName(user) {
    if (user?.role === 'locum' && user?.airwallexInfo?.beneficiaryId != null) {
        if (
            user.bankVerification?.verified === 0 &&
            user.bankVerification?.amount !== null
        ) {
            return 'bank_account_verify';
        }

        return 'bank_account_change';
    }

    if (user?.billing?.bankAccountName == null) {
        return 'bank_account';
    }

    return 'bank_account_change';
}
